import {Map, fromJS, List} from "immutable";

import {FETCH_INVOICES_STATS_REQUEST, FETCH_INVOICES_STATS_SUCCESS, FETCH_INVOICES_STATS_ERROR, CLEAN_INVOICES_STATS_STATE} from "./invoices-stats-actions";

const invoicesStats = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        // Requests
        case FETCH_INVOICES_STATS_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false
            });
            return newState;

        // Success
        case FETCH_INVOICES_STATS_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false
            });
            return newState;

        // Errors
        case FETCH_INVOICES_STATS_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;

        // Clean State
        case CLEAN_INVOICES_STATS_STATE:
            newState = state.merge({
                payload: undefined,
                isFetching: false,
                error: false
            });
            return newState;

        default:
            return state;
    }
};

export default invoicesStats;